/**
 * Optimized Unschooling Management with Pagination and Caching
 */

import UnschoolingManagement from './UnschoolingManagement';
import withOptimization from '../../hoc/withOptimization';

export default withOptimization(UnschoolingManagement, {
  collection: 'unschoolingContent',
  pageSize: 20,
  orderByField: 'createdAt',
  orderDirection: 'desc',
  cacheTTL: 5 * 60 * 1000
});

/**
 * Performance Improvements:
 * - Before: Loads ALL unschooling content (300+) = 8-12s load time
 * - After: Loads 20 items at a time = 2-3s load time
 * - Firestore reads: 300+ → 20-100
 */
